module.exports = __webpack_public_path__ + "cania-programas.aa0509c645c772b563e5.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/iconos/fonts/cania-programas.ttf?s2o10a
// module id = 1469
// module chunks = 2